import { useState } from 'react'
import { motion } from 'motion/react'
import { Boton, Campo } from '../components/ui'
import { useSession } from '../lib/session'

/**
 * No hay registro abierto: o entras con tu usuario o vienes con un código de
 * invitación de quien ya está dentro.
 */
export function Login() {
  const { login, register } = useSession()
  const [modo, setModo] = useState<'entrar' | 'invitacion'>('entrar')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [inviteCode, setInviteCode] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  async function enviar(event: React.FormEvent): Promise<void> {
    event.preventDefault()
    setError(null)
    setEnviando(true)
    try {
      if (modo === 'entrar') await login(username, password)
      else await register({ username, password, displayName, inviteCode })
    } catch (caught) {
      setError((caught as Error).message)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <motion.form
      onSubmit={enviar}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 260, damping: 28 }}
      className="mx-auto max-w-md pt-[12vh]"
    >
      <img src="/icons/icon-192.png" alt="" className="mb-6 h-16 w-16 rounded-2xl" />
      <p className="label-caps text-primary">Bienvenida a casa</p>
      <h1 className="mt-2 font-display text-5xl leading-[0.95]">Recetario de Lucía</h1>
      <p className="mb-8 mt-3 text-muted-foreground">
        Qué comemos, qué hay que comprar y cómo queda el día.
      </p>

      {error && (
        <p className="mb-4 rounded-2xl border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">
          {error}
        </p>
      )}

      <Campo id="usuario" label="Usuario">
        <input
          id="usuario"
          className="campo bg-card"
          value={username}
          autoComplete="username"
          onChange={(event) => setUsername(event.target.value)}
        />
      </Campo>

      <Campo id="clave" label="Contraseña">
        <input
          id="clave"
          type="password"
          className="campo bg-card"
          value={password}
          autoComplete={modo === 'entrar' ? 'current-password' : 'new-password'}
          onChange={(event) => setPassword(event.target.value)}
        />
      </Campo>

      {modo === 'invitacion' && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }}>
          <Campo id="nombre" label="Tu nombre">
            <input
              id="nombre"
              className="campo bg-card"
              value={displayName}
              onChange={(event) => setDisplayName(event.target.value)}
            />
          </Campo>
          <Campo id="codigo" label="Código de invitación">
            <input
              id="codigo"
              className="campo bg-card tracking-[0.2em]"
              value={inviteCode}
              autoCapitalize="characters"
              onChange={(event) => setInviteCode(event.target.value.toUpperCase())}
            />
          </Campo>
        </motion.div>
      )}

      <Boton type="submit" variante="principal" ancho className="mt-2" disabled={enviando}>
        {modo === 'entrar' ? 'Entrar' : 'Unirme al hogar'}
      </Boton>

      <Boton
        ancho
        className="mt-2.5"
        onClick={() => {
          setModo(modo === 'entrar' ? 'invitacion' : 'entrar')
          setError(null)
        }}
      >
        {modo === 'entrar' ? 'Tengo un código de invitación' : 'Ya tengo usuario'}
      </Boton>
    </motion.form>
  )
}
